import styled from 'styled-components';

import { InfoBlock } from './InfoBlock';

export const InfoBlockFullSize = styled(InfoBlock)`
  width: 100%;

  &.actions {
    button {
      max-width: 200px;
    }
  }
`;
